// src/pages/DemoData/index.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";

const DemoData = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };
  document.title = "Demo Data | EIRNABio Connect";

  return (
    <div className="page-content">
      <Container fluid>
        {/* Page Header */}
        <Row className="mb-3">
          <Col lg={12}>
            <h4 className="mb-0 fw-bold" style={{ color: "#374151" }}>
              Demo Data
            </h4>
          </Col>
        </Row>

        {/* Main Content */}
        <Row>
          <Col>
            <Card
              style={{
                border: "2px solid #e5e7eb",
                borderRadius: "2px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              <CardBody style={{ padding: "32px" }}>
                {/* Title */}
                <div className="d-flex align-items-center mb-4">
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#f0fdf4",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                    }}
                  >
                    <i
                      className="ri-database-2-line"
                      style={{
                        fontSize: "20px",
                        color: "#2F9E37",
                      }}
                    ></i>
                  </div>
                  <h2
                    className="mb-0 fw-bold"
                    style={{
                      color: "#2F9E37",
                      fontSize: "24px",
                    }}
                  >
                    EIRNABio Connect Demo Data
                  </h2>
                </div>

                {/* Content */}
                <div className="mb-4">
                  <div className="d-flex align-items-start mb-3">
                    <i
                      className="ri-information-line me-3 mt-1"
                      style={{ color: "#6b7280", fontSize: "16px" }}
                    ></i>
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#374151",
                      }}
                    >
                      The purpose of the EIRNABio Connect demo data is to
                      provide you with a means to explore our high quality{" "}
                      <strong>Ribo-Seq</strong>, <strong>Disome-Seq</strong>,{" "}
                      <strong>RNA-Seq</strong> and <strong>Polysome-Seq</strong>{" "}
                      data through the various functions available on the EIRNA
                      Bio Connect platform.
                    </p>
                  </div>

                  <div className="d-flex align-items-start mb-3">
                    <i
                      className="ri-flask-line me-3 mt-1"
                      style={{ color: "#6b7280", fontSize: "16px" }}
                    ></i>
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#374151",
                      }}
                    >
                      Inspired by our colleagues' previous work{" "}
                      <em>(Andreev, O'Connor, et al., 2015)</em>, HEK293 cells
                      were treated with sodium arsenite for 60 minutes (Arsenite
                      labelled samples). When the Arsenite-treated samples are
                      compared to the untreated samples (Control labelled
                      samples), a strong mRNA translation response is observed
                      similar to that reported by{" "}
                      <em>(Andreev, O'Connor, et al., 2015)</em>.
                    </p>
                  </div>

                  <div className="d-flex align-items-start mb-3">
                    <i
                      className="ri-computer-line me-3 mt-1"
                      style={{ color: "#6b7280", fontSize: "16px" }}
                    ></i>
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#374151",
                      }}
                    >
                      EIRNABio Connect is an online browser-based platform that
                      allows you to interactively explore and analyse
                      transcriptome-wide high-throughput sequencing data. By
                      clicking on the samples of interest and dragging them to
                      the relevant functionality input selection box, you can
                      interrogate this data without needing any prior
                      bioinformatics experience. Click on the Help tab and
                      follow the Walkthrough Example or have a look at any of
                      the Help videos.
                    </p>
                  </div>

                  <div className="d-flex align-items-start mb-3">
                    <i
                      className="ri-shield-check-line me-3 mt-1"
                      style={{ color: "#6b7280", fontSize: "16px" }}
                    ></i>
                    <p
                      className="mb-0"
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.6",
                        color: "#374151",
                      }}
                    >
                      We encourage you to check out the quality of EIRNABio
                      data by examining the quality control checks on the
                      Connect platform (follow the instructions for the Data
                      Quality plots). Feel free to have a look at more
                      analytical functionality by clicking on the thumbnails
                      which includes{" "}
                      <strong>Differential Expression analysis</strong>,{" "}
                      <strong>Pause Prediction</strong>, differential decoding
                      rates (<strong>Codon occupancy</strong> thumbnail),{" "}
                      <strong>Differential Distribution algorithms</strong>, and
                      lots more.
                    </p>
                  </div>
                </div>

                {/* Call to Action */}
                <div
                  className="text-center p-4 mb-4"
                  style={{
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <h5
                    className="fw-semibold mb-3"
                    style={{
                      color: "#1f2937",
                      fontSize: "18px",
                    }}
                  >
                    Stay Tuned For How{" "}
                    <span style={{ color: "#2F9E37" }}>EIRNABio Connect</span>{" "}
                    Can Provide Actionable Insights For Your Own Data
                  </h5>
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      lineHeight: "1.6",
                    }}
                  >
                    Over the course of the coming months, we will illustrate how
                    the EIRNABio Connect functionality can help advance your
                    own research questions. We will showcase the different
                    functionalities using this demonstration data to help you
                    gain more insights with your own data.
                  </p>
                </div>

                {/* Reference */}
                <div
                  style={{
                    borderTop: "1px solid #e5e7eb",
                    paddingTop: "20px",
                  }}
                >
                  <div className="d-flex align-items-start">
                    <i
                      className="ri-book-line me-3 mt-1"
                      style={{ color: "#6b7280", fontSize: "16px" }}
                    ></i>
                    <div>
                      <h6
                        className="fw-semibold mb-2"
                        style={{ color: "#374151", fontSize: "14px" }}
                      >
                        References
                      </h6>
                      <p
                        style={{
                          fontSize: "13px",
                          lineHeight: "1.5",
                          color: "#6b7280",
                          marginBottom: "0",
                        }}
                      >
                        1. Andreev DE, O'Connor PBF, Fahey C, Kenny EM, Terenin
                        IM, Dmitriev SE, Cormican P, Morris DW, Shatsky IN,
                        Baranov PV (2015) Translation of 5′ leaders is pervasive
                        in genes resistant to eIF2 repression. Elife Jan
                        26:4:e03971.{" "}
                        <a
                          href="https://doi.org/10.7554/eLife.03971"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#2F9E37",
                            textDecoration: "none",
                          }}
                        >
                          https://doi.org/10.7554/eLife.03971
                          <i className="ri-external-link-line ms-1"></i>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DemoData;
